export default {
  badge: 'Emblem',
  open: 'Åbn',
  close: 'Luk',
  dismiss: 'Afvis',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Annuller',
  },
  dataIterator: {
    noResultsText: 'Ingen matchende data fundet',
    loadingText: 'Indhenter data...',
  },
  dataTable: {
    itemsPerPageText: 'Rækker pr. side:',
    ariaLabel: {
      sortDescending: 'Sorteret faldende.',
      sortAscending: 'Sorteret stigende.',
      sortNone: 'Ikke sorteret.',
      activateNone: 'Aktiver for at fjerne sortering.',
      activateDescending: 'Aktiver for at sortere faldende.',
      activateAscending: 'Aktiver for at sortere stigende.',
      selectRow: 'Vælg række',
      selectAll: 'Vælg alle',
      selectGroup: 'Vælg gruppe',
    },
    sortBy: 'Sorter efter',
  },
  dataFooter: {
    itemsPerPageText: 'Rækker pr. side:',
    itemsPerPageAll: 'Alle',
    nextPage: 'Næste side',
    prevPage: 'Forrige side',
    firstPage: 'Første side',
    lastPage: 'Sidste side',
    pageText: '{0}-{1} af {2}',
  },
  dateRangeInput: {
    divider: 'til',
  },
  monthPicker: {
    title: 'Vælg måned',
    itemsSelected: '{0} valgt',
    header: 'Indtast måned',
    range: {
      title: 'Indtast måneder',
    },
    ariaLabel: {
      previousYear: 'Forrige år',
      nextYear: 'Næste år',
      selectYear: 'Vælg år',
      currentMonth: 'Denne måned, {0}',
    },
  },
  datePicker: {
    itemsSelected: '{0} valgt',
    range: {
      title: 'Vælg datoer',
      header: 'Indtast datoer',
    },
    title: 'Vælg dato',
    header: 'Indtast dato',
    input: {
      placeholder: 'Indtast dato',
    },
    ariaLabel: {
      previousMonth: 'Forrige måned',
      nextMonth: 'Næste måned',
      selectYear: 'Vælg år',
      previousYear: 'Forrige år',
      nextYear: 'Næste år',
      selectMonth: 'Vælg måned',
      selectDate: '{0}',
      currentDate: 'I dag, {0}',
    },
  },
  noDataText: 'Ingen data tilgængelig',
  carousel: {
    prev: 'Forrige visuelle',
    next: 'Næste visuelle',
    ariaLabel: {
      delimiter: 'Karrusel dias {0} af {1}',
    },
  },
  calendar: {
    moreEvents: '{0} mere',
    today: 'I dag',
  },
  heatmap: {
    less: 'Mindre',
    more: 'Mere',
  },
  input: {
    clear: 'Ryd {0}',
    prependAction: '{0} foranstillet handling',
    appendAction: '{0} efterstillet handling',
    otp: 'Indtast OTP-tegn {0}',
  },
  fileInput: {
    counter: '{0} filer',
    counterSize: '{0} filer ({1} i alt)',
  },
  fileUpload: {
    title: 'Træk og slip filer her',
    divider: 'eller',
    browse: 'Gennemse filer',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Vælg tidspunkt',
    hour: 'Time',
    minute: 'Minutter',
    second: 'Sekunder',
    notAllowed: 'Værdien er ikke tilladt',
  },
  pagination: {
    ariaLabel: {
      root: 'Pagineringsnavigation',
      next: 'Næste side',
      previous: 'Forrige side',
      page: 'Gå til side {0}',
      currentPage: 'Nuværende side, Side {0}',
      first: 'Første side',
      last: 'Sidste side',
    },
  },
  stepper: {
    next: 'Næste',
    prev: 'Forrige',
  },
  rating: {
    ariaLabel: {
      item: 'Bedømmelse {0} af {1}',
    },
  },
  loading: 'Indlæser...',
  infiniteScroll: {
    loadMore: 'Indlæs mere',
    empty: 'Ingen flere',
  },
  rules: {
    required: 'Dette felt er påkrævet',
    email: 'Indtast venligst en gyldig e-mail',
    number: 'Dette felt kan kun indeholde tal',
    integer: 'Dette felt kan kun indeholde heltal',
    capital: 'Dette felt kan kun indeholde store bogstaver',
    maxLength: 'Du skal indtaste maksimalt {0} tegn',
    minLength: 'Du skal indtaste mindst {0} tegn',
    strictLength: 'Længden af det indtastede felt er ugyldig',
    exclude: 'Tegnet {0} er ikke tilladt',
    notEmpty: 'Vælg venligst mindst én værdi',
    pattern: 'Ugyldigt format',
  },
  command: {
    search: 'Skriv en kommando eller søg...',
  },
  hotkey: {
    then: 'derefter',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Pil op',
    downArrow: 'Pil ned',
    leftArrow: 'Pil venstre',
    rightArrow: 'Pil højre',
    backspace: 'Slet',
    space: 'Mellemrum',
    plus: 'plus',
    shortcut: 'Tastaturgenvej: {0}',
    or: 'eller',
  },
  video: {
    play: 'Afspil',
    pause: 'Pause',
    seek: 'Søg',
    volume: 'Lydstyrke',
    showVolume: 'Vis lydstyrkekontrol',
    mute: 'Slå lyd fra',
    unmute: 'Slå lyd til',
    enterFullscreen: 'Fuld skærm',
    exitFullscreen: 'Afslut fuld skærm',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Vælg farve fra skærmen',
      hueSlider: 'Farvetone',
      alphaSlider: 'Alfa',
      redInput: 'Rød',
      greenInput: 'Grøn',
      blueInput: 'Blå',
      alphaInput: 'Alfa',
      hueInput: 'Farvetone',
      saturationInput: 'Mætning',
      lightnessInput: 'Lyshed',
      hexInput: 'HEX-værdi',
      hexaInput: 'HEX med alfaværdi',
      changeFormat: 'Skift farveformat',
    },
  },
}
